import * as React from "react";
import { LinearProgress, styled } from "@mui/material";
import { RouteComponentProps } from "react-router";
import { FourOFour } from "../../../containers/404";
import { RosebudColorMap } from "./rosebudColorMap";
import { useDiseasesSections } from "../hooks/useDiseasesSections";
import { featureTo2Lines } from "fe-common/logic";
import { FiveHundred } from "../../../containers/500";
import { usePulse } from "../../../util/usePule";
import { MobileView } from "../../../util/aKaunGeneralUtil";
import { MobileExpandView } from "../../../themeComponents/MobileExpandView";
import MiniDiseaseView from "../miniDisease/miniDiseaseView";
//region [[ Styles ]]
const RosebudMobileBottomNavigationHeight = 40; // Use smaller bottom navigation as it is still in older design
// TODO:import { RosebudMobileBottomNavigationHeight } from "../common/rosebudButtomNavigationButton";

const DiseaseDataContainer = styled("div")(() => ({
  padding: "0px 0",
  backgroundColor: "rgba(255, 255, 255, 0.63)", //TODO: move to rosebudColorMap
  boxShadow: `0 4px 16px 0 ${RosebudColorMap.uglyBlue4}`,
  marginBottom: `${RosebudMobileBottomNavigationHeight + 12}px`,
}));

const DiseaseDataContent = styled("div")({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
});

const DiseaseName = styled("div")(({ theme }) => ({
  fontSize: "36px",
  borderRadius: "5px",
  minWidth: "100px",
  textTransform: "none",
  color: "white",
  fontWeight: 700,
  textAlign: "left",
  [theme.breakpoints.down(MobileView)]: {
    fontSize: "1.4em",
  },
}));

const ProgressBar = styled(LinearProgress)({
  position: "fixed",
  zIndex: 1100,
  top: 0,
  left: 0,
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface ExpandedDiseaseProps
  extends RouteComponentProps<{ qfid: string }> {
  className?: string;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ExpandedDisease = ({ match, className }: ExpandedDiseaseProps) => {
  const qfid = match.params.qfid;

  const { featuresSections, loading } = useDiseasesSections();

  const { transparentPulse, withAnimation } = usePulse({ disabled: !loading });

  const featureWCrs = featuresSections
    .flatMap((section) => section?.elements)
    .find((sfwc) => sfwc?.qf?.id === qfid);

  const feature = featureWCrs?.qf;
  //      --------------------------------------------------------

  const [primary] = !feature || loading ? [] : featureTo2Lines(feature);

  const pulseClass = `${loading ? transparentPulse : ""} ${withAnimation}`;

  const titleCase = (string: String) =>
    string
      .trim()
      .split(" ")
      .map((word) => word[0]?.toUpperCase() + word.slice(1))
      .join(" ");

  // If no id - return 404 error
  if (!qfid || qfid.length === 0 || qfid === "") return <FourOFour />;

  // If no feature was found - hit a friendly 500 for now
  if (!loading && !featureWCrs) return <FiveHundred />;

  return (
    <MobileExpandView
      className={className}
      topProgressBar={loading && <ProgressBar />}
      topAreaTitle={
        <DiseaseName className={pulseClass}>
          {loading ? <>&nbsp;</> : titleCase(primary)}
        </DiseaseName>
      }
    >
      <DiseaseDataContainer className={pulseClass}>
        {!loading && (
          <DiseaseDataContent>
            <MiniDiseaseView fWithCrs={featureWCrs} />
          </DiseaseDataContent>
        )}
      </DiseaseDataContainer>
    </MobileExpandView>
  );
};
